module.exports = __webpack_public_path__ + "static/media/sassIcon.639cffb9.svg";